import { Divider, type DividerProps } from "@/components/Divider";

export function VerticalMenuDivider(props: DividerProps) {
  return <Divider {...props} />;
}
